var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebAppIconCmu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_849_2953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.8696 80.5H19.1304C8.58435 80.5 0 71.9157 0 61.3696V19.6304C0 9.08435 8.58435 0.5 19.1304 0.5H60.8696C71.4157 0.5 80 9.08435 80 19.6304V61.3696C80 71.9157 71.4157 80.5 60.8696 80.5ZM19.1304 3.97826C10.4974 3.97826 3.47826 10.9974 3.47826 19.6304V61.3696C3.47826 70.0026 10.4974 77.0217 19.1304 77.0217H60.8696C69.5026 77.0217 76.5217 70.0026 76.5217 61.3696V19.6304C76.5217 10.9974 69.5026 3.97826 60.8696 3.97826H19.1304Z",
    fill: "url(#paint0_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5908 12.4725C52.5908 11.4986 53.3769 10.7334 54.33 10.7334C55.3039 10.7334 56.0691 11.4986 56.0691 12.4725C56.0691 13.4256 55.3039 14.2117 54.33 14.2117C53.3769 14.2117 52.5908 13.4256 52.5908 12.4725Z",
    fill: "url(#paint1_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0938 12.4725C58.0938 11.4986 58.8798 10.7334 59.8329 10.7334C60.8068 10.7334 61.572 11.4986 61.572 12.4725C61.572 13.4256 60.8068 14.2117 59.8329 14.2117C58.8798 14.2117 58.0938 13.4256 58.0938 12.4725Z",
    fill: "url(#paint2_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6865 12.4725C63.6865 11.4986 64.4726 10.7334 65.4257 10.7334C66.3996 10.7334 67.1648 11.4986 67.1648 12.4725C67.1648 13.4256 66.3996 14.2117 65.4257 14.2117C64.4726 14.2117 63.6865 13.4256 63.6865 12.4725Z",
    fill: "url(#paint3_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9373 16.124H13.6346C12.6746 16.124 11.8955 16.9032 11.8955 17.8632C11.8955 18.8232 12.6746 19.6023 13.6346 19.6023H67.9373C68.8973 19.6023 69.6764 18.8232 69.6764 17.8632C69.6764 16.9032 68.8973 16.124 67.9373 16.124Z",
    fill: "url(#paint4_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7286 10.7539H13.6346C12.6746 10.7539 11.8955 11.533 11.8955 12.493C11.8955 13.453 12.6746 14.2322 13.6346 14.2322H19.7286C20.6886 14.2322 21.4677 13.453 21.4677 12.493C21.4677 11.533 20.6886 10.7539 19.7286 10.7539Z",
    fill: "url(#paint5_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8815 27.2898V43.0115H16.2781V27.2898H63.8815ZM63.8815 23.8115H16.2781C14.3581 23.8115 12.7998 25.3698 12.7998 27.2898V43.0115C12.7998 44.9315 14.3581 46.4898 16.2781 46.4898H63.8815C65.8015 46.4898 67.3598 44.9315 67.3598 43.0115V27.2898C67.3598 25.3698 65.8015 23.8115 63.8815 23.8115Z",
    fill: "url(#paint6_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1511 54.9714V65.8793H16.2781V54.9714H35.1511ZM35.1511 51.4932H16.2781C14.3581 51.4932 12.7998 53.0514 12.7998 54.9714V65.8793C12.7998 67.7992 14.3581 69.3575 16.2781 69.3575H35.1511C37.0711 69.3575 38.6294 67.7992 38.6294 65.8793V54.9714C38.6294 53.0514 37.0711 51.4932 35.1511 51.4932Z",
    fill: "url(#paint7_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.141 56.4665H44.7167C43.7567 56.4665 42.9775 55.6874 42.9775 54.7274C42.9775 53.7674 43.7567 52.9883 44.7167 52.9883H65.141C66.101 52.9883 66.8801 53.7674 66.8801 54.7274C66.8801 55.6874 66.101 56.4665 65.141 56.4665Z",
    fill: "url(#paint8_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.141 62.1638H44.7167C43.7567 62.1638 42.9775 61.3847 42.9775 60.4247C42.9775 59.4647 43.7567 58.6855 44.7167 58.6855H65.141C66.101 58.6855 66.8801 59.4647 66.8801 60.4247C66.8801 61.3847 66.101 62.1638 65.141 62.1638Z",
    fill: "url(#paint9_linear_849_2953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.141 67.8611H44.7167C43.7567 67.8611 42.9775 67.0819 42.9775 66.1219C42.9775 65.1619 43.7567 64.3828 44.7167 64.3828H65.141C66.101 64.3828 66.8801 65.1619 66.8801 66.1219C66.8801 67.0819 66.101 67.8611 65.141 67.8611Z",
    fill: "url(#paint10_linear_849_2953)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_849_2953",
    x: 0,
    y: 0.5,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_849_2953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_849_2953",
    x1: 40,
    y1: 0.5,
    x2: 40,
    y2: 80.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_849_2953",
    x1: 54.33,
    y1: 10.7334,
    x2: 54.33,
    y2: 14.2117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_849_2953",
    x1: 59.8329,
    y1: 10.7334,
    x2: 59.8329,
    y2: 14.2117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_849_2953",
    x1: 65.4257,
    y1: 10.7334,
    x2: 65.4257,
    y2: 14.2117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_849_2953",
    x1: 40.7859,
    y1: 16.124,
    x2: 40.7859,
    y2: 19.6023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_849_2953",
    x1: 16.6816,
    y1: 10.7539,
    x2: 16.6816,
    y2: 14.2322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_849_2953",
    x1: 40.0798,
    y1: 23.8115,
    x2: 40.0798,
    y2: 46.4898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_849_2953",
    x1: 25.7146,
    y1: 51.4932,
    x2: 25.7146,
    y2: 69.3575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_849_2953",
    x1: 54.9288,
    y1: 52.9883,
    x2: 54.9288,
    y2: 56.4665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_849_2953",
    x1: 54.9288,
    y1: 58.6855,
    x2: 54.9288,
    y2: 62.1638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_849_2953",
    x1: 54.9288,
    y1: 64.3828,
    x2: 54.9288,
    y2: 67.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAppIconCmu);
export default __webpack_public_path__ + "static/media/web_app_icon_cmu.fffd6330cb4c58b9dc3b43e7a58a0d52.svg";
export { ForwardRef as ReactComponent };